// React
import React from 'react';
import { Controller } from 'react-hook-form';
// custom components
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import MissionSelectionArray from './components/MissionSelectionArray';

const MissionSelection = (props) => {
  const { control, formState } = props.methods;
  const { errors } = formState;
  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Mission Cards" instructions="Using the controls below, add the mission cards for the Practical Exercise." />
      <Controller 
        control={control}
        name="content.core"
        render={({ field }) => <MissionSelectionArray inputDir={inputDir} {...{control, errors }} />}
      />
    </div>
  )
}

export default MissionSelection;